export const canViewBerkas = (user: User): boolean => {
  if (isFeaturePermit(user.role.permissions, 'berkas')) {
    return true
  }

  return false;
}

export const canViewPenugasan = (user: User): boolean => {
  if (isFeaturePermit(user.role.permissions, 'penugasan')) {
    return true
  }

  return false;
}

export const canViewSurvey = (user: User): boolean => {
  if (isFeaturePermit(user.role.permissions, 'survey')) {
    return true
  }

  return false;
}

export const canViewPenggambaran = (user: User): boolean => {
  if (isFeaturePermit(user.role.permissions, 'penggambaran')) {
    return true
  }

  return false;
}

export const canViewOverlay = (user: User): boolean => {
  if (isFeaturePermit(user.role.permissions, 'overlay')) {
    return true
  }

  return false;
}

export const canViewPengesahan = (user: User): boolean => {
  if (isFeaturePermit(user.role.permissions, 'pengesahan_kasi')) {
    return true
  }

  if (isFeaturePermit(user.role.permissions, 'pengesahan_kabid')) {
    return true
  }

  if (isFeaturePermit(user.role.permissions, 'pengesahan_sekdis')) {
    return true
  }

  if (isFeaturePermit(user.role.permissions, 'pengesahan_kadis')) {
    return true
  }

  return false;
}


export const canViewKasi = (user: User): boolean => {
  if (isFeaturePermit(user.role.permissions, 'pengesahan_kasi')) {
    return true
  }

  return false;
}

export const canViewKabid = (user: User): boolean => {
  if (isFeaturePermit(user.role.permissions, 'pengesahan_kabid')) {
    return true
  }

  return false;
}

export const canViewSekdis = (user: User): boolean => {
  if (isFeaturePermit(user.role.permissions, 'pengesahan_sekdis')) {
    return true
  }

  return false;
}

export const canViewKadis = (user: User): boolean => {
  if (isFeaturePermit(user.role.permissions, 'pengesahan_kadis')) {
    return true
  }

  return false;
}

export const canViewPengiriman = (user: User): boolean => {
  if (isFeaturePermit(user.role.permissions, 'pengiriman')) {
    return true
  }

  return false;
}

export const canViewConfig = (user: User): boolean => {
  if (isFeaturePermit(user.role.permissions, 'config')) {
    return true
  }

  return false;
}

export const canViewUser = (user: User): boolean => {
  if (isFeaturePermit(user.role.permissions, 'user_management')) {
    return true
  }

  return false;
}

const isFeaturePermit = (arr: UserPermission[], document: string): boolean => {
  const find = arr.find((data) => data.feature.slug === document);
  if (!find) {
    return false;
  }

  return find.canView;
}

